var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDevices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 53.16,
  height: 58.16,
  viewBox: "0 0 53.16 58.16",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "devices")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.71,0H19a1.16,1.16,0,0,0-1.16,1.16v25A1.15,1.15,0,0,0,19,27.32H37.71a1.15,1.15,0,0,0,1.16-1.15v-25A1.16,1.16,0,0,0,37.71,0ZM28.36,26.62a1.06,1.06,0,1,1,1.05-1.06A1.05,1.05,0,0,1,28.36,26.62ZM38,22.67a1.16,1.16,0,0,1-1.16,1.16H19.9a1.16,1.16,0,0,1-1.16-1.16V2.08A1.16,1.16,0,0,1,19.9.92H36.81A1.16,1.16,0,0,1,38,2.08Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52,30.83H38.26A1.16,1.16,0,0,0,37.1,32V57a1.16,1.16,0,0,0,1.16,1.16H52A1.15,1.15,0,0,0,53.16,57V32A1.15,1.15,0,0,0,52,30.83ZM45.13,57.45a1.06,1.06,0,1,1,1.06-1.05A1.06,1.06,0,0,1,45.13,57.45Zm7.13-3.94a1.16,1.16,0,0,1-1.16,1.16H39.16A1.16,1.16,0,0,1,38,53.51V32.91a1.16,1.16,0,0,1,1.16-1.16H51.1a1.16,1.16,0,0,1,1.16,1.16Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,53.11H2a2,2,0,0,1-1.95-2V32.67a2,2,0,0,1,2-2H30a2,2,0,0,1,1.95,2V51.16A2,2,0,0,1,30,53.11ZM2,31.55A1.12,1.12,0,0,0,.83,32.67V51.16A1.12,1.12,0,0,0,2,52.27H30a1.12,1.12,0,0,0,1.12-1.11V32.67A1.12,1.12,0,0,0,30,31.55Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.42,49v2.49a1.19,1.19,0,0,0,1.19,1.2H30.38a1.2,1.2,0,0,0,1.2-1.2V49Zm28.74,2.86a.81.81,0,1,1,.81-.81A.8.8,0,0,1,29.16,51.86Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.68,58H9.31a1.22,1.22,0,0,1,1.22-1.21H13.2a.73.73,0,0,0,.72-.73V53.9h4.15v2.2a.73.73,0,0,0,.73.73h2.66A1.21,1.21,0,0,1,22.68,58Z",
  fill: "currentColor"
})))));
export default SvgDevices;